export default "__VITE_ASSET__BoIHKR78__"